import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { Link, useMatches } from 'react-router-dom';
import { SecondaryAppBar } from '@marageti/z4-lib';
import { ViewProps, TabItem, SecondaryAppbarTabsProps } from './types';

const SubNavigationTabs = ({ tabs }: SecondaryAppbarTabsProps) => {
  const matches = useMatches();
  const activeTab = matches.find((match) => {
    const matchedTab = match.handle as { tab: string };
    return Boolean(matchedTab?.tab);
  }) as { handle: { tab: string } } | undefined;

  return (
    <Tabs value={activeTab?.handle.tab}>
      {tabs.map((item: TabItem) => (
        <Tab
          data-e2e={item.e2e}
          key={`${item.to}${item.label}`}
          value={`/${item.to}`}
          label={item.label?.toUpperCase() || item.to.toUpperCase()}
          disableRipple
          component={Link}
          to={item.to}
          replace={item.replace ?? true}
        />
      ))}
    </Tabs>
  );
};

const SubNavigationView = ({
  profile = undefined,
  startAdornment = undefined,
  endAdornment = undefined,
  tabs = undefined,
}: ViewProps) => (
  <SecondaryAppBar
    collapsing
    position="sticky"
    color="default"
    profile={profile}
    startAdornment={startAdornment}
    endAdornment={endAdornment}
    tabs={tabs ? <SubNavigationTabs tabs={tabs} /> : undefined}
    ToolbarProps={{
      variant: 'light',
    }}
    sx={{ zIndex: 1110 }}
  />
);

export default SubNavigationView;
